module.exports = __webpack_public_path__ + "img/Path11866.faa12ccb.svg";